import React from 'react';
import TaxReturnQuestionsPage from "../TaxReturnQuestionsPage";
export function taxReturnQuestionsRoutes() { return [{ path: '/tax_return_questions', element: /*#__PURE__*/ React.createElement(TaxReturnQuestionsPage, null) }]; }
